var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.5V2C1 1.44772 1.44772 1 2 1H6.375C6.92728 1 7.375 1.44772 7.375 2V8.5C7.375 9.05229 6.92728 9.5 6.375 9.5H2C1.44772 9.5 1 9.05229 1 8.5Z",
    stroke: "#BAB7AF",
    strokeWidth: 1.5,
    className: "svg-secondary"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 1H12.625C12.0727 1 11.625 1.44772 11.625 2V4.25C11.625 4.80228 12.0727 5.25 12.625 5.25H17C17.5523 5.25 18 4.80228 18 4.25V2C18 1.44772 17.5523 1 17 1Z",
    stroke: "#BAB7AF",
    strokeWidth: 1.5,
    className: "svg-secondary"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 13.75H2C1.44772 13.75 1 14.1977 1 14.75V17C1 17.5523 1.44772 18 2 18H6.375C6.92728 18 7.375 17.5523 7.375 17V14.75C7.375 14.1977 6.92728 13.75 6.375 13.75Z",
    fill: "#BAB7AF",
    className: "svg-primary"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.0312H12.625C12.0727 10.0312 11.625 10.479 11.625 11.0312V17C11.625 17.5523 12.0727 18 12.625 18H17C17.5523 18 18 17.5523 18 17V14.0156V11.0312C18 10.479 17.5523 10.0312 17 10.0312Z",
    className: "svg-primary"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.983ccb41.svg";
export { ForwardRef as ReactComponent };